import React, { useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as rive from "@rive-app/canvas";
import { Loader } from "./Loader";

export const SplashView = () => {
    const navigate = useNavigate();
    const location = useLocation();


    const showAnimation = () => {
        // new rive.Rive({
        //     // Hosted .riv asset, or a local static asset
        //     src: "/semp-animation.riv",
        //     canvas: document.getElementById("canvas"),
        //     layout: new rive.Layout({ fit: rive.Fit.FitWidth, alignment: rive.Alignment.Center }),
        //     autoplay: true,
        //   });
    }
    // once
    useLayoutEffect(() => {
        setTimeout(() => {
            navigate("/home");
        }, 1000);
        showAnimation();

    }, [])

    return (
        <div className="h-full w-full justify-items-center content-center">
            <Loader enabled status="Carregando..." />
        </div>
    )
}